import { handleActions } from 'redux-actions';
import { presenceActions } from '../../presence/actions/presenceActions';
import { teamActions } from '../actions/teamPage';
const { selectTeamMembersFilter, teamToggleAgentDetails, setPresenceFilters } = teamActions;
const { presenceGetAllSucceeded } = presenceActions;
export const initialState = {
    ui: {
        filter: 'online',
    },
    teamAgents: [],
    agentsDetail: {},
    presenceFilters: {},
};
const team = handleActions({
    [selectTeamMembersFilter.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { filter: action.payload.filter }) });
    },
    [presenceGetAllSucceeded.toString()]: (state, action) => {
        const teamAgents = [];
        action.payload.data.forEach((userPresence) => teamAgents.push({ id: userPresence.user.id, isOpen: false }));
        return Object.assign(Object.assign({}, state), { teamAgents });
    },
    [teamToggleAgentDetails.toString()]: (state, action) => {
        const { id } = action.payload;
        return Object.assign(Object.assign({}, state), { agentsDetail: Object.assign(Object.assign({}, state.agentsDetail), { [id.toString()]: !state.agentsDetail[id] }) });
    },
    [setPresenceFilters.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { presenceFilters: action.payload });
    },
}, initialState);
export default team;
